<template>
    <v-form ref='form' @submit.prevent="onSubmit">
        <v-container>
            <v-row v-for="(row,index) in content" :key="index">
                <v-col v-for="(item,j) in row" cols="12" :md="item.cols" :key="j"
                    :class="{ 'd-flex justify-center': item.type === 'action' }">
                    <keep-alive>
                        <component v-if="item.type ==='input'"
                            :is="item.component" 
                            v-bind="item.params"
                            v-model="item.params.value" 
                        ></component>
                        <component v-else-if="item.type ==='action'"
                            :is="item.component" 
                            v-bind="item.params"
                            @click="item.action(values)"
                        ></component>
                    </keep-alive>
                </v-col>
            </v-row>
            <slot name="actions" :values="values">
            </slot>
        </v-container>    
    </v-form>
</template>

<script>
import FormTextField from "./FormInputs/FormTextField.vue"
import FormSelectField from './FormInputs/FormSelectField.vue'
import FormDateField from './FormInputs/FormDateField.vue'
import FormTableSelectField from './FormInputs/FormTableSelectField.vue'
import BaseBtn from '../UI/BaseBtn.vue'


    export default {
        props: {
            content  : {
                type: Array,
                default: () => []
            },
            submit: {
                type: Function,
                default: null
            }
        },
        emits: ['submit'],

        components: {
            FormTextField,
            FormSelectField,
            FormDateField,
            FormTableSelectField,
            BaseBtn
        },

        data(){
            return {
                values : {}
            }
        },
        methods: {
          onSubmit(){
                const valid = this.$refs.form.validate();
                if(!valid){
                    console.log("Form is invalid");
                    return;
                }
                console.log("submit", this.values);
                if(this.submit){
                    this.submit(this.values);
                }
                this.$emit('submit', this.values);
          }  
        },
        updated(){
            // console.log("content:", this.content);
            this.content.forEach( (row) => {
                row.forEach( (item) => {
                    if(item.params && item.params.name !== undefined){
                        this.values[item.params.name] = item.params.value;
                    }
                });
            });   
        },
        created(){
            // console.log("Created content:", this.content);
            this.content.forEach( (row) => {
                row.forEach( (item) => {
                    if(item.params && item.params.name !== undefined){
                        this.values[item.params.name] = item.params.value;
                    }
                });
            });   
        }
    }
</script>
